import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import WidgetContext from 'State/WidgetContext';
import { Labels } from 'Helpers';
import Icon from 'Components/Icon';

class Filters extends PureComponent {
    constructor() {
        super();

        this.state = { isOpen: false, currentOrder: null };

        this.triggerRef = React.createRef();
        this.optionsRef = React.createRef();

        this.handleClick = this.handleClick.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClick);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick);
    }

    onChange(newOrder) {
        const { isOffer } = this.props;
        const { id, setSortOrder } = this.context;

        setSortOrder(id, isOffer ? 'offers' : 'rates', newOrder);
        this.setState({ isOpen: false, currentOrder: newOrder });
    }

    /**
     * The method reacts to the caller by considering whether the caller is inside the component
     */
    handleClick(e) {
        const { isOpen } = this.state;
        const [ options, trigger ] = [ this.optionsRef && this.optionsRef.current, this.triggerRef && this.triggerRef.current ];

        if (!isOpen && trigger.contains(e.target)) {
            this.setState({ isOpen: true });
        } else if (isOpen && (trigger.contains(e.target) || !options.contains(e.target))) {
            this.setState({ isOpen: false });
        }
    }

    render() {
        const { hidden, isOffer } = this.props;
        const { isOpen, currentOrder } = this.state;

        let sortOrder;
        let sortBy = '';
        let isSortOrderSelected = false;

        // First the labels are brought with them, then a new arrangement is made with the necessary format for its rendering
        const availableFilters = Labels.getSortOptions(isOffer).map((filterOption, i) => {
            // When a title is found, it is stored until the selected item is found in the list
            sortBy = filterOption.sortOrder === 'title' && !isSortOrderSelected ? filterOption.text : sortBy;
            let className = filterOption.className || '';

            if (filterOption.sortOrder === currentOrder) {
                sortOrder = filterOption.text;
                className = 'kbe-active';
                isSortOrderSelected = true;
            }
            return {
                key     : `${filterOption.sortOrder}-${i}`,
                text    : filterOption.text,
                onClick : () => this.onChange(filterOption.sortOrder),
                className,
            };
        });

        return (
            <div className={`kbe-text-right kbe-margin-bottom ${hidden ? 'kbe-hidden' : ''}`}>
                <div className="kbe-dropdown kbe-dropdown-right kbe-text-left kbe-filter-dropdown">
                    <div className={`kbe-flex kbe-flex-middle kbe-dropdown-click ${isOpen ? 'kbe-active' : ''}`} ref={this.triggerRef}>
                        <span className="kbe-dropdown-details">
                            {
                                isSortOrderSelected
                                    ? <><strong>{ sortBy }</strong>: { sortOrder }</>
                                    : <FormattedMessage id="bf.sortBy" defaultMessage="bf.sortBy" />
                            }
                        </span>
                        <Icon name="CaretDown" className="kbe-margin-left-small" size="10" />
                    </div>
                    { isOpen ? <div className="kbe-dropdown-menu occupancy-selector-wrapper" ref={this.optionsRef}>
                        <ul>
                            {availableFilters.map(option => <li key={option.key} {...option}>{option.text}</li>)}
                        </ul>
                    </div> : null}
                </div>
            </div>
        );
    }
}

Filters.contextType = WidgetContext;

Filters.defaultProps = { hidden: false };
Filters.propTypes = {
    hidden  : PropTypes.bool,
    isOffer : PropTypes.bool.isRequired,
};

export default Filters;
